export const VIEWPORT_SIZE = 1366
